/**
 * 全局缓存变量。
 * 环境在应用生命周期内不会改变，所以只需要检测一次并缓存结果。
 */
let _isElectronCache: boolean | null = null;

const detectElectron = (): boolean => {
  if (typeof window === "undefined") return false;

  // 1. 优先检查 webview 注入的 bridge (ContextBridge 在脚本执行前已注入，无需异步等待)
  if ((window as any).electronBridge) return true;

  // 2. 检查 electronAPI (BrowserWindow 环境)
  if ((window as any).electronAPI) return true;

  // 3. User Agent 检查
  if (navigator && /electron/i.test(navigator.userAgent)) return true;

  return false;
};

/**
 * Hook: 获取当前是否在 Electron 环境
 * 现在它是同步的，不会导致组件重渲染。
 */
export const useElectronEnvironment = (): boolean => {
  // 惰性求值：只有第一次调用时才执行检测
  if (_isElectronCache === null) {
    _isElectronCache = detectElectron();
    // 只会在控制台打印一次
    console.log(
      `🖥️ [Environment] Detected: ${_isElectronCache ? "Electron App" : "Browser"}`
    );
  }
  return _isElectronCache;
};

/**
 * 普通函数：获取当前是否在 Electron 环境 (供非组件代码使用)
 */
export const getIsElectron = (): boolean => {
  if (_isElectronCache === null) {
    _isElectronCache = detectElectron();
  }
  return _isElectronCache;
};
